import { mutationTypes as mutation } from './mutations'

const GET_PAGING_LIMIT = 'getPagingLimit'

export const actionTypes = {
  GET_PAGING_LIMIT
}

export const actions = {
  [GET_PAGING_LIMIT] ({ commit }, payload) {
    localStorage.setItem('employeeboard_paginglimit', payload)
    commit(mutation.SET_PAGING_LIMIT, payload)
  }
}



// WEBPACK FOOTER //
// ./src/store/module/employeeboard/actions.js